
import { Languages } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useTranslation } from 'react-i18next';

interface LanguageFilterProps {
  selectedLanguage: string;
  onLanguageChange: (language: string) => void;
}

const LanguageFilter = ({ selectedLanguage, onLanguageChange }: LanguageFilterProps) => {
  const { t } = useTranslation('practitioners');

  const languages = [
    { code: 'all', name: t('languageFilter.allLanguages') },
    { code: 'en', name: 'English' },
    { code: 'zh', name: '中文 (Chinese)' },
    { code: 'es', name: 'Español (Spanish)' },
    { code: 'fr', name: 'Français (French)' },
    { code: 'de', name: 'Deutsch (German)' },
    { code: 'ja', name: '日本語 (Japanese)' },
    { code: 'ko', name: '한국어 (Korean)' },
    { code: 'pt', name: 'Português (Portuguese)' },
    { code: 'ru', name: 'Русский (Russian)' },
    { code: 'ar', name: 'العربية (Arabic)' },
    { code: 'hi', name: 'हिन्दी (Hindi)' },
    { code: 'it', name: 'Italiano (Italian)' },
    { code: 'nl', name: 'Nederlands (Dutch)' },
    { code: 'pl', name: 'Polski (Polish)' },
    { code: 'tr', name: 'Türkçe (Turkish)' },
    { code: 'vi', name: 'Tiếng Việt (Vietnamese)' },
    { code: 'th', name: 'ไทย (Thai)' },
    { code: 'id', name: 'Bahasa Indonesia' },
    { code: 'ms', name: 'Bahasa Melayu (Malay)' },
    { code: 'sv', name: 'Svenska (Swedish)' },
    { code: 'no', name: 'Norsk (Norwegian)' },
    { code: 'da', name: 'Dansk (Danish)' },
    { code: 'fi', name: 'Suomi (Finnish)' },
    { code: 'el', name: 'Ελληνικά (Greek)' },
    { code: 'he', name: 'עברית (Hebrew)' },
    { code: 'cs', name: 'Čeština (Czech)' },
    { code: 'hu', name: 'Magyar (Hungarian)' },
    { code: 'ro', name: 'Română (Romanian)' },
    { code: 'uk', name: 'Українська (Ukrainian)' },
  ];

  return (
    <div>
      <h3 className="text-sm font-semibold mb-3 flex items-center">
        <Languages className="mr-2 h-4 w-4 text-amber-600" /> {t('languageFilter.title')}
      </h3>
      <Select value={selectedLanguage} onValueChange={onLanguageChange}>
        <SelectTrigger className="w-full border-amber-200">
          <SelectValue placeholder={t('languageFilter.selectLanguage')} />
        </SelectTrigger>
        <SelectContent className="max-h-[300px]">
          {languages.map(lang => (
            <SelectItem key={lang.code} value={lang.code}>
              {lang.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default LanguageFilter;
